import dayjs from 'dayjs';
import { MapUtils } from '../../utility/map-utils.js';
import { TimeZone } from '../../time/timezone.js';
import {
  DataModel, DataModelBuilder, isSameList,
  SerializationContext, SerializedData,
} from '../dto/dto.js';

export class CustomerAuthDetails extends DataModel {
  static readonly TYPE_ID: string = '8240a2bb46f747a3a61e2cdc11c0022a';

  constructor(
    public readonly uniqueId: string,
    public readonly creationDate: dayjs.Dayjs,
    public readonly email: string | null,
    public readonly phoneNumber: string | null,
    public readonly authenticationProviders: string[],
  ) {
    super();
  }

  get $typeId(): string {
    return CustomerAuthDetails.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): CustomerAuthDetails {
    return new CustomerAuthDetails(
        MapUtils.get<string>(map, 'uniqueId'),
        context.decodeDate(MapUtils.get<number>(map, 'creationDate')),
        MapUtils.getOrNull<string>(map, 'email'),
        MapUtils.getOrNull<string>(map, 'phoneNumber'),
        MapUtils.getList(map, 'authenticationProviders', (e) => e as string),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'uniqueId': this.uniqueId,
      'creationDate': context.encodeDate(this.creationDate),
      'email': this.email,
      'phoneNumber': this.phoneNumber,
      'authenticationProviders': this.authenticationProviders,
    };
  }

  clone(): this {
    return new CustomerAuthDetails(
        this.uniqueId,
        TimeZone.cloneDate(this.creationDate),
        this.email,
        this.phoneNumber,
        this.authenticationProviders.map((e) => e),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.uniqueId === this.uniqueId &&
        other.creationDate === this.creationDate &&
        other.email === this.email &&
        other.phoneNumber === this.phoneNumber &&
        isSameList(other.authenticationProviders, this.authenticationProviders);
  }
}

export class CustomerAuthDetailsBuilder extends DataModelBuilder<CustomerAuthDetails> {
  build(context: SerializationContext, map: SerializedData): CustomerAuthDetails {
    return CustomerAuthDetails.fromMap(context, map);
  }
}
